import { accountDetailsRequestHandler, deleteAccountRequestHandler } from '../../Utilities/ApiRequestHandler';

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twitter/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_twitter',
  );
}

export async function authorizeTwitterAccount(sessionId: string) {
  if (!sessionId || sessionId === '') return;
  return await fetch(`${process.env.REACT_APP_API_PATH}/connections/twitter/auth-start`, {
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        window.location.assign(json.authLink);
      } else if (response.status === 403) {
        window.location.assign('/');
      } else {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return error;
    });
}

export async function getAuthResult(sessionId: string, queryString: string) {
  if (!sessionId || sessionId === '' || !queryString || queryString === '') return;
  return await fetch(`${process.env.REACT_APP_API_PATH}/connections/twitter/auth-result?${queryString}`, {
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        const json = await response.json();
        return {
          success: true,
          result: json.result,
        };
      } else {
        return {
          success: false,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        success: false,
        result: null,
      };
    });
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twitter/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_twitter',
  );
}
